import { render, staticRenderFns } from "./multipane.vue?vue&type=template&id=64b1c300"
import script from "./multipane.vue?vue&type=script&lang=js"
export * from "./multipane.vue?vue&type=script&lang=js"
import style0 from "./multipane.vue?vue&type=style&index=0&id=64b1c300&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports